import React from 'react';
import CandidatesTable from './table/CandidatesTable';

/**
 * Página principal de candidatos.
 * Renderiza la tabla de candidatos.
 * 
 * @component
 * @returns {JSX.Element} Componente de la tabla de candidatos.
 */
const CandidatesPage = () => (
    <CandidatesTable />
);

export default CandidatesPage;